import { useLang } from '@/i18n';
import EfNavProduct, { EfNavProductItemProps } from '@elem/ui/ef-nav-product';
import { useRouter } from 'next/router';
import { useProductDispatch, useProductStore } from '../../ProductProvider';

export default function NavProduct() {
    const { t } = useLang('theProduct.NavProduct');
    const { productPageData } = useProductStore();
    const { locale } = useRouter();
    const dispatch = useProductDispatch();
    const list: EfNavProductItemProps[] = [
        {
            type: 'Product',
            title: t('tab1'),
        },
        {
            type: 'Bundles',
            title: t('tab2'),
        },
        ...(locale === 'cn'
            ? [
                  {
                      type: 'Specs',
                      title: t('tab4'),
                  },
                  {
                      type: 'Support',
                      title: t('tab3'),
                  },
              ]
            : [
                  {
                      type: 'Support',
                      title: t('tab3'),
                  },
                  {
                      type: 'Specs',
                      title: t('tab4'),
                  },
              ]),
        {
            type: 'Media',
            title: t('tab5'),
        },
    ];
    const buyItem = {
        type: locale === 'jp' ? 'Bundles' : 'Product',
        title: t('buy_now'),
        hash: 'id-OtherA',
        href: productPageData?.productDetail?.buyLink || '',
    };
    const itemCallback = (item: any, isNoneMove?: boolean) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.type,
        });
        if (!isNoneMove) {
            // 切换时划回顶部
            setTimeout(() => {
                (document.querySelector('#page-back-to-top') as any).scrollIntoView(true);
            }, 100);
        }
    };
    const buyCallback = (item: any) => {
        if (locale === 'jp') {
            itemCallback({
                type: 'Bundles',
            });
        } else {
            itemCallback(
                {
                    type: 'Product',
                },
                true,
            );
            setTimeout(() => {
                (document.querySelector('#id-OtherA') as any).scrollIntoView(true);
            }, 100);
        }
    };
    return (
        <>
            <div id="page-back-to-top"></div>
            <EfNavProduct
                selectType="Product"
                name={t('product_name')}
                list={list}
                buyItem={buyItem}
                callback={itemCallback}
                buyCallback={buyCallback}
                locale={locale}
            ></EfNavProduct>
        </>
    );
}
